module.exports = __webpack_public_path__ + "static/media/shop-and-rental.01b6abc3.svg";